<template>
  <div>
    <BaseFrame
      cancelText=""
      clearText=""
      :infosArr="infos"
    >
      <div class="container" slot="content">
        <lk-card title="商品票折详情">
          <div style="display:flex;flex-wrap:wrap;">
            <div v-for="item in goodsDetail" style="display:flex;width:33%;" :key="item.id">
              <div style="width:30%;text-align:right;margin-bottom:12px;">{{`${item.title}：`}}</div>
              <div>{{detailInfos[item.key]}}</div>
            </div>
          </div>
        </lk-card>
        <lk-card title="商品批次明细">
          <div style="display:flex;">
            <div>
              批次号:
              <lk-select v-model="batchNum" style="width:260px;" :clearable="true" :filterable="true">
                <lk-option v-for="item in batchNumList" :value="item.inventoryId" :key="item.inventoryId">{{item.goodsBatchSeq}}</lk-option>
              </lk-select>
            </div>
            <div style="display:flex;margin:0 0 20px 20px;">
              <lk-button  @click="toSearch" style="margin-right:20px;">查询</lk-button>
              <DownloadButton  @on-click="download" v-if="handlePermission('profitToatalAnalysisCheckDownLoad')"></DownloadButton>
            </div>
          </div>
          <div>
            <lk-table border :columns="columns" :data="tableData"></lk-table>
          </div>
        </lk-card>
      </div>
    </BaseFrame>
  </div>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';
import DownloadButton from '../../components/download/DownloadButton.vue';
import queryMixins from '../../mixins/queryMixins';
import finance from '../../services/finance';
import utils from '../../libs/utils';

export default {
  name: 'profitToatalAnalysisCheck',
  mixins: [queryMixins],
  components: {
    BaseFrame,
    DownloadButton,
  },
  data() {
    return {
      params: {},
      batchNum: null,
      batchNumList: [],
      tableData: [],
      detailInfos: {},
      infos: [],
      goodsDetail: [
        {
          id: 1,
          title: '销售数量',
          key: 'saleNum',
        },
        {
          id: 2,
          title: '平均销售单价',
          key: 'salePriceWithOutTax',
        },
        {
          id: 3,
          title: '平均成本单价',
          key: 'originPriceWithOutTax',
        },
        {
          id: 4,
          title: '实际收入(不含税)',
          key: 'saleAmountWithoutTax',
        },
        {
          id: 5,
          title: '实际成本(不含税)',
          key: 'originInputAmoutWithoutTax',
        },
        {
          id: 6,
          title: '实际毛利',
          key: 'realGrossProfitStr',
        },
        {
          id: 7,
          title: '期望毛利',
          key: 'expectGrossProfit',
        },
        {
          id: 8,
          title: '毛利差额',
          key: 'expectAndRealDiff',
        },
        {
          id: 9,
          title: '门店营销成本',
          key: 'marketingCost',
        },
        {
          id: 10,
          title: '预估总票折',
          key: 'expectTotalRebateAmount',
        },
        {
          id: 11,
          title: '已回款票折',
          key: 'payableRebateAmount',
        },
        {
          id: 12,
          title: '其他回款',
          key: 'otherRebateAmount',
        },
        {
          id: 13,
          title: '待回款票折',
          key: 'diffRebateAmount',
        },
      ],
      columns: [
        { title: '序号', type: 'index', minWidth: 80 },
        { title: '批次号', key: 'goodsBatchSeq', minWidth: 116 },
        { title: '入库时间', key: 'createTimeStr', minWidth: 116 },
        { title: '销售数量', key: 'saleNum', minWidth: 116 },
        { title: '平均售价', key: 'salePriceWithOutTax', minWidth: 116 },
        { title: '实际收入(不含税)', key: 'saleAmountWithoutTax', minWidth: 116 },
        { title: '成本单价', key: 'originPriceWithOutTax', minWidth: 116 },
        { title: '实际成本(不含税)', key: 'originInputAmoutWithoutTax', minWidth: 116 },
        { title: '实际毛利', key: 'realGrossProfit', minWidth: 116 },
        { title: '期望毛利', key: 'expectGrossProfit', minWidth: 116 },
        { title: '门店营销成本', key: 'marketingCost', minWidth: 116 },
        { title: '预估总票折', key: 'expectTotalRebateAmount', minWidth: 116 },
        { title: '已录入发票票折', key: 'payableRebateAmount', minWidth: 116 },
        { title: '已录入其他回款', key: 'otherRebateAmount', minWidth: 116 },
        { title: '待回款票折', key: 'diffRebateAmount', minWidth: 116 },
      ],
    }
  },
  methods: {
    download() {
      let params = utils.deepClone(this.params);
      params.goodsStoreIdList = [params.goodsStoreIdList];
      params.supplierStoreIdList = [params.supplierStoreIdList];
      params.inventoryIdList = this.batchNum;
      finance.doloadBatchList(params).then(res => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    toSearch() {
      let params = utils.deepClone(this.params);
      params.goodsStoreIdList = [params.goodsStoreIdList];
      params.supplierStoreIdList = [params.supplierStoreIdList];
      params.inventoryIdList = this.batchNum;
      finance.getBatchList(params).then(res => {
        if (res.data.status === 200) {
          res.data.data.list.forEach(item => {
            item.createTimeStr = utils.formatDate(item.createTime);
          })
          this.tableData = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    getArguments() {
      let { goodsStoreId, supplierStoreId, saleTime, rebateTime } = this.$route.query;
      let isHaveSaleTime = false, isHaveRebateTime =false;
      if (saleTime && saleTime.length) {
        isHaveSaleTime = true;
      }
      if (rebateTime && rebateTime.length) {
        isHaveRebateTime = true;
      }
      this.params = {
        goodsStoreIdList: goodsStoreId,
        supplierStoreIdList: supplierStoreId,
        saleTimeStart: isHaveSaleTime ? saleTime[0] : '',
        saleTimeEnd: isHaveSaleTime ? saleTime[1] : '',
        rebateTimeStart:  isHaveRebateTime ? rebateTime[0] : '',
        rebateTimeEnd: isHaveRebateTime ? rebateTime[1] : '',
      }
    },
    getBaseInfos() {
      finance.getDetailInfo(this.params).then(res => {
        if (res.data.status === 200) {
          let data = res.data.data.financeRebateStatsVo;
          data.realGrossProfitStr = `${data.realGrossProfit} (${data.realGrossProfitRate})`
          this.detailInfos = data;
          let goosName = `${data.drugSerialCode} ${data.approvedDrugName ? data.approvedDrugName : ''} ${data.goodsName ? `(${data.goodsName})` : ""}`;
          this.infos = [
            {
              name: '门店:',
              value: data.storeName,
            },
            {
              name: '供应商:',
              value: data.supplierName,
            },
            {
              name: '商品:',
              value: goosName,
            },
            {
              name: '标准毛利率:',
              value: data.rateStr,
            },
            {
              name: '是否计提:',
              value: data.isProvisionStr,
            },
            {
              name: '销售日期:',
              value: res.data.data.saleRange,
            },
            {
              name: '票折日期:',
              value: res.data.data.rebateRange,
            },
          ]
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    getBatchNumList() {
      finance.getBatchNumList(this.params).then(res => {
        if (res.data.status === 200) {
          this.batchNumList = res.data.data || [];
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
  },
  mounted() {
    this.getArguments();
    this.getBaseInfos();
    this.getBatchNumList();
    this.toSearch();
  }
}
</script>
<style>

</style>